var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntegrations(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 147,
    height: 172.497,
    viewBox: "0 0 147 172.497",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_177",
    x: 0,
    y: 25.497,
    width: 147,
    height: 147,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_201",
    "data-name": "Rectangle 201",
    width: 61,
    height: 59,
    transform: "translate(0 -0.234)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_402",
    "data-name": "Group 402",
    transform: "translate(-1010.5 -3329.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_374",
    "data-name": "Group 374",
    transform: "translate(671 770.923)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_843",
    "data-name": "Path 843",
    d: "M361.162,128.6l2.3-1.836a2.433,2.433,0,0,0-2.816,1.546,3.911,3.911,0,0,0-2.91.18l4.593,1.668a3.476,3.476,0,0,0-1.163-1.557Z",
    transform: "translate(81.31 2448.929)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_844",
    "data-name": "Path 844",
    d: "M735.046,77.5l2.3-1.836a2.433,2.433,0,0,0-2.816,1.546,3.911,3.911,0,0,0-2.91.18l4.593,1.668A3.476,3.476,0,0,0,735.046,77.5Z",
    transform: "translate(-319.479 2492.157)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_367",
    "data-name": "Group 367",
    transform: "translate(-564.132 180.631) rotate(-17)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 11.168,
    cy: 22.788,
    rx: 11.168,
    ry: 22.788,
    transform: "translate(174.65 2546.304)",
    fill: "#5d45ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_853",
    "data-name": "Path 853",
    d: "M549.9,218.79c4.473-26.838.045-53.578,0-53.845l-.87.147c.045.265,4.448,26.866,0,53.553Z",
    transform: "translate(-365.109 2387.603)",
    fill: "#f8e602"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_182",
    "data-name": "Rectangle 182",
    width: 0.883,
    height: 11.453,
    transform: "translate(175.569 2564.97) rotate(-61.858)",
    fill: "#f8e602"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_183",
    "data-name": "Rectangle 183",
    width: 11.454,
    height: 0.883,
    transform: "translate(186.229 2572.303) rotate(-28.158)",
    fill: "#f8e602"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_368",
    "data-name": "Group 368",
    transform: "translate(696.433 34.469) rotate(11)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8-2",
    "data-name": "Ellipse 8",
    cx: 9.109,
    cy: 18.587,
    rx: 9.109,
    ry: 18.587,
    transform: "translate(174.65 2546.304)",
    fill: "#5d45ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_853-2",
    "data-name": "Path 853",
    d: "M549.735,208.862c3.648-21.889.037-43.7,0-43.917l-.71.12c.037.217,3.628,21.912,0,43.679Z",
    transform: "translate(-366.818 2386.452)",
    fill: "#f8e602"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_182-2",
    "data-name": "Rectangle 182",
    width: 0.72,
    height: 9.342,
    transform: "translate(175.399 2561.529) rotate(-61.858)",
    fill: "#f8e602"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_183-2",
    "data-name": "Rectangle 183",
    width: 9.342,
    height: 0.72,
    transform: "translate(184.094 2567.51) rotate(-28.158)",
    fill: "#f8e602"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_855",
    "data-name": "Path 855",
    d: "M663.565,209.25l2.3-1.836a2.433,2.433,0,0,0-2.816,1.546,3.911,3.911,0,0,0-2.91.18l4.593,1.668A3.476,3.476,0,0,0,663.565,209.25Z",
    transform: "translate(-242.272 2375.306)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1010.5, 3329)",
    filter: "url(#Rectangle_177)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_177-2",
    "data-name": "Rectangle 177",
    width: 114,
    height: 114,
    rx: 5,
    transform: "translate(16.5 39)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_386",
    "data-name": "Group 386",
    transform: "translate(1051 3396.234)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_385",
    "data-name": "Group 385",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_965",
    "data-name": "Path 965",
    d: "M9.041,22.483a3.556,3.556,0,0,1-3.569-3.45c0-.357.119-.714.119-.952H.952A.938.938,0,0,1,0,17.13V.833A.848.848,0,0,1,.952,0H17.13a.848.848,0,0,1,.952.833V7.019a.9.9,0,0,1-.595.833.733.733,0,0,1-.833-.119,1.789,1.789,0,0,0-1.309-.476,1.686,1.686,0,0,0-1.784,1.784,1.83,1.83,0,0,0,1.784,1.784,2.494,2.494,0,0,0,1.309-.476.7.7,0,0,1,.833-.119.754.754,0,0,1,.595.714V17.13a.919.919,0,0,1-.952.833H12.491c0,.357.119.714.119.952a3.579,3.579,0,0,1-3.569,3.569",
    fill: "#9be48e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_966",
    "data-name": "Path 966",
    d: "M17.13,360.963H.952A.848.848,0,0,1,0,360.13v-16.3A.848.848,0,0,1,.952,343H7.138a.652.652,0,0,1,.714.476.737.737,0,0,1-.119.952A1.767,1.767,0,0,0,9.041,347.4a1.856,1.856,0,0,0,1.9-1.784,1.652,1.652,0,0,0-.595-1.19.931.931,0,0,1-.119-.952.8.8,0,0,1,.833-.476H17.13a.848.848,0,0,1,.952.833v4.758a2.205,2.205,0,0,1,.833-.238,3.579,3.579,0,0,1,3.569,3.569,3.505,3.505,0,0,1-3.569,3.569,2.024,2.024,0,0,1-.833-.119v4.639a.938.938,0,0,1-.952.952",
    transform: "translate(0 -302.197)",
    fill: "#5f8b88",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_967",
    "data-name": "Path 967",
    d: "M377.249,327.483h-16.3a.919.919,0,0,1-.952-.833v-6.186a.9.9,0,0,1,.595-.833.733.733,0,0,1,.833.119,1.982,1.982,0,0,0,1.309.476,1.752,1.752,0,0,0,1.784-1.784,1.83,1.83,0,0,0-1.784-1.784,1.982,1.982,0,0,0-1.309.476.7.7,0,0,1-.833.119.754.754,0,0,1-.595-.714v-6.186a.919.919,0,0,1,.952-.833h4.639c0-.357-.119-.714-.119-.952a3.569,3.569,0,1,1,7.138,0c0,.357-.119.595-.119.952h4.639a.848.848,0,0,1,.952.833v16.3a.813.813,0,0,1-.833.833",
    transform: "translate(-317.175 -268.718)",
    fill: "#91d7fe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_968",
    "data-name": "Path 968",
    d: "M344.651,17.963h-6.186a.652.652,0,0,1-.714-.476.737.737,0,0,1,.119-.952,2.114,2.114,0,0,0,.476-1.19,1.83,1.83,0,0,0-1.784-1.784,1.856,1.856,0,0,0-1.9,1.784,1.527,1.527,0,0,0,.476,1.19,1.282,1.282,0,0,1,.238.952.9.9,0,0,1-.833.476h-6.186a.919.919,0,0,1-.952-.833V12.372a2.205,2.205,0,0,1-.833.238A3.579,3.579,0,0,1,323,9.041a3.505,3.505,0,0,1,3.569-3.569,2.024,2.024,0,0,1,.833.119V.833A.919.919,0,0,1,328.353,0h16.178a.848.848,0,0,1,.952.833v16.3a.813.813,0,0,1-.833.833",
    transform: "translate(-284.576)",
    fill: "#2adfbb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_969",
    "data-name": "Path 969",
    d: "M176.729,168.2h-2.5a.9.9,0,0,1-.833-.595l-.714-2.855a2.431,2.431,0,0,1-1.071-.595l-2.379,1.546a.886.886,0,0,1-1.071-.119l-1.784-1.665a1.184,1.184,0,0,1-.119-1.071l1.546-2.5a8.2,8.2,0,0,1-.476-1.19l-2.617-.595a1.021,1.021,0,0,1-.714-.833v-2.5a.9.9,0,0,1,.595-.833l2.974-.714a4.225,4.225,0,0,1,.476-1.071l-1.428-2.379a.764.764,0,0,1,.119-1.071l1.665-1.784a1.184,1.184,0,0,1,1.071-.119l2.5,1.546a8.2,8.2,0,0,1,1.19-.476l.595-2.617a1.036,1.036,0,0,1,.952-.714h2.379a1.112,1.112,0,0,1,.833.595l.714,2.974a4.226,4.226,0,0,1,1.071.476l2.379-1.428a.753.753,0,0,1,1.071.119l1.784,1.784a.72.72,0,0,1,.119.952l-1.546,2.5a8.2,8.2,0,0,1,.476,1.19l2.736.595a.942.942,0,0,1,.595.952v2.379a.9.9,0,0,1-.595.833l-2.855.714a4.822,4.822,0,0,1-.595,1.071l1.546,2.379a1.118,1.118,0,0,1-.119,1.071l-1.784,1.665a.764.764,0,0,1-1.071.119l-2.5-1.427a8.2,8.2,0,0,1-1.19.476l-.595,2.617a.9.9,0,0,1-.833.595",
    transform: "translate(-144.491 -127.751)",
    fill: "#b3bacb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_970",
    "data-name": "Path 970",
    d: "M228.52,215.922a4.461,4.461,0,1,1,4.4-4.4,4.391,4.391,0,0,1-4.4,4.4",
    transform: "translate(-197.353 -182.376)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_971",
    "data-name": "Path 971",
    d: "M208.9,63.784H197.833a.848.848,0,0,1-.833-.952.813.813,0,0,1,.833-.833h11.182a.813.813,0,0,1,.833.833.938.938,0,0,1-.952.952",
    transform: "translate(-173.565 -54.625)",
    fill: "#2adfbb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_972",
    "data-name": "Path 972",
    d: "M197.612,45.943a.909.909,0,0,1-.595-.238.933.933,0,0,1,0-1.309l2.379-2.379a.8.8,0,0,1,1.19,0,.933.933,0,0,1,0,1.309l-2.379,2.379a.909.909,0,0,1-.595.238",
    transform: "translate(-173.345 -36.783)",
    fill: "#2adfbb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_973",
    "data-name": "Path 973",
    d: "M199.992,65.824c-.238,0-.476,0-.595-.238l-2.379-2.26a.933.933,0,0,1,0-1.309.8.8,0,0,1,1.19,0l2.379,2.379a.8.8,0,0,1,0,1.19.655.655,0,0,1-.595.238",
    transform: "translate(-173.345 -54.404)",
    fill: "#2adfbb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_974",
    "data-name": "Path 974",
    d: "M81.952,212.848a.919.919,0,0,1-.952-.833V200.833a.919.919,0,0,1,.952-.833.813.813,0,0,1,.833.833v11.182a.894.894,0,0,1-.833.833",
    transform: "translate(-71.364 -176.208)",
    fill: "#9be48e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    "data-name": "Path 975",
    d: "M64.992,277.824a.909.909,0,0,1-.595-.238l-2.379-2.379a.8.8,0,0,1,0-1.19.934.934,0,0,1,1.309,0l2.26,2.379a.8.8,0,0,1,0,1.19,2.01,2.01,0,0,1-.595.238",
    transform: "translate(-54.404 -241.185)",
    fill: "#9be48e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_976",
    "data-name": "Path 976",
    d: "M82.612,277.824a.909.909,0,0,1-.595-.238.8.8,0,0,1,0-1.19l2.379-2.379a.841.841,0,0,1,1.19,1.19l-2.379,2.379a2.01,2.01,0,0,1-.595.238",
    transform: "translate(-72.025 -241.185)",
    fill: "#9be48e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_977",
    "data-name": "Path 977",
    d: "M231.015,409.784H219.833a.813.813,0,0,1-.833-.833.919.919,0,0,1,.833-.952h11.182a1.023,1.023,0,0,1,.952.952.919.919,0,0,1-.952.833",
    transform: "translate(-192.948 -359.465)",
    fill: "#5f8b88",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_978",
    "data-name": "Path 978",
    d: "M294.612,412.824a.909.909,0,0,1-.595-.238.934.934,0,0,1,0-1.309l2.26-2.26a.933.933,0,0,1,1.309,0,.792.792,0,0,1,0,1.19l-2.379,2.379a2.01,2.01,0,0,1-.595.238",
    transform: "translate(-258.806 -360.126)",
    fill: "#5f8b88",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_979",
    "data-name": "Path 979",
    d: "M295.992,392.824c-.238,0-.476,0-.595-.238l-2.379-2.379a.8.8,0,0,1,0-1.19.933.933,0,0,1,1.309,0l2.26,2.379a.8.8,0,0,1,0,1.19c-.119.238-.357.238-.595.238",
    transform: "translate(-257.925 -342.505)",
    fill: "#5f8b88",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_980",
    "data-name": "Path 980",
    d: "M428.833,189.848a.813.813,0,0,1-.833-.833V177.952a.848.848,0,0,1,.833-.952.938.938,0,0,1,.952.952v11.063a1.009,1.009,0,0,1-.952.833",
    transform: "translate(-377.086 -155.944)",
    fill: "#91d7fe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_981",
    "data-name": "Path 981",
    d: "M430.992,180.943a.909.909,0,0,1-.595-.238l-2.379-2.379a.934.934,0,0,1,0-1.309.8.8,0,0,1,1.19,0l2.379,2.379a.934.934,0,0,1,0,1.309.909.909,0,0,1-.595.238",
    transform: "translate(-376.865 -155.724)",
    fill: "#91d7fe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_982",
    "data-name": "Path 982",
    d: "M408.612,180.943a2.01,2.01,0,0,1-.595-.238.934.934,0,0,1,0-1.309l2.379-2.379a.925.925,0,1,1,1.309,1.309l-2.379,2.379a1.691,1.691,0,0,1-.714.238",
    transform: "translate(-359.244 -155.724)",
    fill: "#91d7fe",
    fillRule: "evenodd"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrations);
export default __webpack_public_path__ + "static/media/integrations.38cdd1146dba45fbcde59ddabc3d9e34.svg";
export { ForwardRef as ReactComponent };